export const getAuthorizationHeader = () => {
  const cognitoToken = Object.keys(sessionStorage).reduce((acc, key) => {
    if (
      key.startsWith('CognitoIdentityServiceProvider') &&
      key.endsWith('idToken')
    ) {
      return sessionStorage.getItem(key) || acc;
    }
    return acc;
  }, '');
  return cognitoToken || localStorage.getItem('cn_ti_token') || '';
};
